import { createAction } from '@ngrx/store';

enum PinnedUIActionTypes {
  GetAllPinned = '[Pinned Items UI] Get All Pinned Items',
}

export const GetAllPinned = createAction(PinnedUIActionTypes.GetAllPinned);
